// Module
var code = "<section> <div ng-repeat=\"toast in $ctrl.toasts\"> <div ng-bind-html=\"toast.msg\" class=\"toast {{ ::toast.customClass }}\"></div> </div> </section> ";
// Exports
export default code;